import posthog from 'posthog-js';

const isProduction = process.env.NODE_ENV === 'production';

export function capturePageView() {
  // console.log('$pageview')
  if(isProduction) {
    posthog.capture('$pageview')
  }
}
export function idendify(idendifier: any) {
  if(isProduction) {
    posthog.identify(idendifier)
  }
}

export function captureEvent(eventName: any, properties: any) {
  if(isProduction) {
    posthog.capture(eventName, properties);
  }
}


export function resetSession (){
  if(isProduction) {
    posthog.reset();
  }
}


export const create = (idendifier = null) => {
  return posthog.init(
    "phc_3wtM1diMW1yXemIgp2xQklL7XeMcA2z6BJVY5nyK8ix",
    {
      api_host: 'https://eu.posthog.com',
      autocapture: false,
      capture_pageview:false,
      loaded(e) {
        if (idendifier) {
          e.identify(idendifier);
        }
      },
    });
}

export default posthog

